
import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { FlashMessagesService } from 'angular2-flash-messages';
import { AccountClientDetailsService } from '../../../account-client/service/account-client-edit/account-client-details.service';
import { IMyDpOptions } from 'mydatepicker';

export interface AlertModel {
  clientObj;
}

@Component({
  selector: 'app-bc-insurance-modal',
  templateUrl: './bc-insurance-modal.component.html',
  styleUrls: ['./bc-insurance-modal.component.scss'],
  providers: [AccountClientDetailsService]
})

export class BcInsuranceModalComponent extends DialogComponent<AlertModel, boolean> implements AlertModel {

  clientObj;
  private clientID;
  public dataEnvioSeguradora;

  private myDatePickerOptions: IMyDpOptions = {
		// other options...
		dayLabels:{su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab'},
		monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
		dateFormat: 'dd/mm/yyyy',
		showTodayBtn: false,
		//disableSince: {year: this.today.getFullYear(), month: this.today.getMonth()+1, day: this.today.getDate()},
		//disableUntil: {year: this.today.getFullYear(), month: this.today.getMonth()+1, day: this.today.getDate()},
		//disableDateRanges: [{begin: {year: 2016, month: 11, day: 14}, end: {year: 2016, month: 11, day: 20}}],
		//editableDateField: false,
		height: "30px"
	};

  constructor(dialogService: DialogService, private accountClientDetailsService:AccountClientDetailsService, private flashMessagesService: FlashMessagesService) {
    super(dialogService);
  }


  ngOnInit(){
    this.clientID = this.clientObj.ID
  }

  confirm(){

    var obj = {
      ContaClienteId: this.clientID,
      UpdateSeguradora: true,
      DataSeguradora: this.dataEnvioSeguradora? this.dataEnvioSeguradora.date.year+"-"+this.dataEnvioSeguradora.date.month+"-"+this.dataEnvioSeguradora.date.day: null,    }

    this.accountClientDetailsService.updateFinancial(obj).subscribe(result => {
      if (result.Success) {
        this.flashMessagesService.show("Data de envio a seguradora registrada com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
        this.close();
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
      }
    }, error => {
      console.log(error);
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/billing-control/bc-account-client/bc-insurance-modal/bc-insurance-modal.component.ts